import { Link } from "react-router-dom";
import Offcanvas from "../../ui/Offcanvas/Offcanvas";
import logo from "../../../../logo.png";
import { useEffect, useState, useRef } from "react";
import { getSession } from "@/utils/session";
import { getCustomerDetails } from "@/services/dreamscapeApi";

// Separated HeaderContent to allow reusing the layout for both static and sticky states
interface HeaderContentProps {
    className?: string;
    style?: React.CSSProperties;
}

function HeaderContent({ className, style }: HeaderContentProps) {
    return (
        <nav className={className} style={style}>
            <div className="relative flex items-center justify-center">
                <Link to="/" className="relative flex items-center gap-3 text-white hover:opacity-90 transition z-10 group">
                    <img
                        src={logo}
                        alt="SAN micron Logo"
                        className="h-14 sm:h-16 md:h-20 lg:h-[64px] xl:h-[80px] w-auto drop-shadow-lg transition-transform group-hover:scale-110 group-hover:rotate-3 header-logo"
                    />
                    <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-2xl xl:text-4xl font-bold  logo-text">
                        <span className="text-white">
                            SAN micron
                        </span>
                    </h1>
                </Link>
            </div>
            <div className="header-nav-container">
                <nav className="flex gap-5 md:gap-10 lg:gap-7 xl:gap-10 text-white text-sm items-center">
                    <Link to="/domains" className="hidden font-bold text-[16px] lg:inline-flex text-white hover:text-blue-200 transition whitespace-nowrap">
                        Domains
                    </Link>
                    <Link to="/websites" className="hidden font-bold text-[16px] lg:inline-flex text-white hover:text-blue-200 transition whitespace-nowrap">
                        Websites
                    </Link>
                    <Link to="/email-hosting" className="hidden font-bold text-[16px] lg:inline-flex text-white hover:text-blue-200 transition whitespace-nowrap">
                        Emails
                    </Link>
                    <Link to="/nas" className="hidden font-bold text-[16px] lg:inline-flex text-white hover:text-blue-200 transition whitespace-nowrap">
                        NAS
                    </Link>
                    <Link to="/voip-service" className="hidden font-bold text-[16px] lg:inline-flex text-white hover:text-blue-200 transition whitespace-nowrap">
                        VoIP Service
                    </Link>
                    <Link to="/social" className="hidden font-bold text-[16px] lg:inline-flex text-white hover:text-blue-200 transition whitespace-nowrap">
                        Social
                    </Link>

                    {/* {import.meta.env.VITE_USE_DB !== 'false' && (
                        session ? (
                            <div className="relative">
                                <button
                                    onClick={() => setMenuOpen(!menuOpen)}
                                    className="w-9 h-9 rounded-full bg-gradient-to-br from-purple-600 to-indigo-600 text-white font-bold flex items-center justify-center shadow-md hover:opacity-90 transition"
                                    aria-label="User menu"
                                >
                                    {getAvatarInitials(session.email, session.username, session.firstName, session.lastName)}
                                </button>
                                {menuOpen && (
                                    <div className="absolute right-0 mt-2 w-44 bg-cardBg/90 border border-white/10 rounded-lg shadow-xl backdrop-blur-md p-2 flex flex-col items-start z-50">
                                        <Link
                                            to="/profile"
                                            onClick={() => setMenuOpen(false)}
                                            className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 rounded-md block transition-colors"
                                        >
                                            My Profile
                                        </Link>
                                        <button
                                            onClick={() => {
                                                handleLogout();
                                                setMenuOpen(false);
                                            }}
                                            className="w-full text-left px-3 py-2 text-sm text-red-300 hover:text-red-200 hover:bg-white/10 rounded-md transition-colors"
                                        >
                                            Logout
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <Link to="/login" className="font-bold text-[16px] text-white hover:text-blue-200 whitespace-nowrap transition-colors">
                                Login
                            </Link>
                        )
                    )} */}


                    <div className="flex-shrink-0">
                        <Offcanvas />
                    </div>
                </nav>
            </div>
        </nav>
    );
}

function Header() {
    const [session, setSession] = useState(getSession());
    const [showSticky, setShowSticky] = useState(false);
    const lastScrollY = useRef(0);
    // Flag to suppress scroll handler during programmatic scroll restoration
    const suppressScroll = useRef(false);

    useEffect(() => {
        const i = setInterval(() => {
            setSession(getSession());
        }, 10_000); // Check every 10s for updates from other tabs/sessions

        // Background sync for currency if missing but logged in
        if (session && !localStorage.getItem('preferredCurrency')) {
            getCustomerDetails(session.customerId).then(res => {
                if (res.success && res.customer) {
                    const country = (res.customer.country || res.customer.country_code || '').toUpperCase();
                    let prefCurrency = 'AUD';
                    if (country === 'NP' || country === 'NEPAL') prefCurrency = 'NRS';
                    else if (country === 'AU' || country === 'AUSTRALIA') prefCurrency = 'AUD';
                    localStorage.setItem('preferredCurrency', prefCurrency);
                }
            }).catch(err => console.error("Header currency sync error:", err));
        }

        return () => clearInterval(i);
    }, [session]);

    useEffect(() => {
        const handleScroll = () => {
            // Skip scroll logic while offcanvas is restoring scroll position
            if (suppressScroll.current) return;

            const currentScrollY = window.scrollY;

            if (currentScrollY < 100) {
                setShowSticky(false);
            } else {
                if (currentScrollY < lastScrollY.current) {
                    // Scrolling Up
                    setShowSticky(true);
                } else {
                    // Scrolling Down
                    setShowSticky(false);
                }
            }
            lastScrollY.current = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        // Listen for offcanvas open/close events to suppress scroll handler
        const handleOffcanvasOpen = () => {
            suppressScroll.current = true;
        };
        const handleOffcanvasClose = (e: Event) => {
            const detail = (e as CustomEvent).detail;
            // Sync lastScrollY to the restored position so the next real scroll
            // doesn't falsely trigger "scrolling up"
            if (typeof detail?.scrollY === "number") {
                lastScrollY.current = detail.scrollY;
            }
            // Keep suppressed for a short frame to let the browser settle
            requestAnimationFrame(() => {
                suppressScroll.current = false;
            });
        };

        window.addEventListener("offcanvas:open", handleOffcanvasOpen);
        window.addEventListener("offcanvas:close", handleOffcanvasClose);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("offcanvas:open", handleOffcanvasOpen);
            window.removeEventListener("offcanvas:close", handleOffcanvasClose);
        };
    }, []);

    return (
        <>
            {/* Original Header - Visible in Hero, scrolls away naturally */}
            <HeaderContent
                className="relative z-[100] flex items-center justify-between px-3 py-8 md:px-28 -mt-4 md:-mt-6 header-container"
            />

            {/* Sticky Header - Appears when scrolling up, Glassmorphism enabled */}
            <HeaderContent
                className={`fixed top-0 left-0 right-0 z-[500] flex items-center justify-between px-3 py-4 md:px-28 transition-all duration-500 ease-in-out header-container ${showSticky ? "translate-y-0" : "-translate-y-full"
                    }`}
                style={{
                    background: 'rgba(0, 0, 0, 0.7)',
                    backdropFilter: 'blur(12px)',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                    pointerEvents: showSticky ? 'auto' : 'none'
                }}
            />
        </>
    );
}

export default Header;